import React, { useMemo } from "react";
import { Col } from "antd";
import {
    evaluateItemProps,
    evaluationType
} from "../../../../service/evaluate";
import Cards from "../Cards";
import Pie from "../Pie";
import WordCloud from "../WordCloud";
import Style from "../../index.module.scss";
import Table from "../Table";

interface Props {
    data: evaluateItemProps;
}
const Index = ({ data }: Props) => {
    const width = useMemo(() => {
        switch (data.queTypeId) {
            case evaluationType.checkbox:
                return 24;
            case evaluationType.radio:
                return 24;
            case evaluationType.textarea:
                return 24;
            default:
                return 12;
        }
    }, [data]);
    const nodes = useMemo(() => {
        switch (data.queTypeId) {
            case evaluationType.checkbox:
                return <WordCloud data={data.data} />;
            case evaluationType.radio:
                return <Pie data={data.data} />;
            case evaluationType.textarea:
                return <Table data={data.data} />;
            default:
                return <div>null</div>;
        }
    }, [data]);
    return (
        <Col span={width}>
            <Cards title={data.title} className={Style.cards}>
                {nodes}
            </Cards>
        </Col>
    );
};

export default Index;
